import template from './main-info.html'

export let mainInfo = {
  bindings: {
    data: '<',
    stackItems: '<',
    module: '<'
  },
  template: template,
  controllerAs: 'vm',
  controller: ['$scope', '$rootScope', '$cookies', '$state', '$stateParams', 'WorkPlanSrv', 'CssClasses', 
    'Validations', 'Ramda', 'GlobalSrv', 'Util',
  function mainInfoCtrl ($scope, $rootScope, $cookies, $state, $stateParams, WorkPlanSrv, CssClasses, Validations, Ramda, GlobalSrv, Util) {
  // constants
    const R = Ramda
    const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
    const inHistory = $stateParams.inHistory
    const currentModule = this.module
    const setDate = Util.setDate
    const unique = Util.unique
    const objHas = Util.objHas
  // variables
    let _details = []
    let _format = []

    let inReview = Validations.inReview(currentStage)
    let inApproval = Validations.inApproval(currentStage)
    let inExecution = Validations.inExecution(currentStage)
    let inReviewExecution = Validations.inReviewExecution(currentStage)
    let inEvaluation = Validations.inEvaluation(currentStage)
    let inTeaching = Validations.inTeaching(currentModule)
    let isSubjectType = Validations.isSubjectType(this.data)
    let isPositionByDelegationType = Validations.isPositionByDelegationType(this.data)
    let isCommitteeParticipationType = Validations.isCommitteeParticipationType(this.data)
    let isDoctoralEducationType = Validations.isDoctoralEducationType(this.data)
    let isTeacherDevelopmentType = Validations.isTeacherDevelopmentType(this.data)
    let isCommunityType = Validations.isCommunityType(this.data)
    let isColaborationSpaceType = Validations.isColaborationSpaceType(this.data)
    let isInvestigationType = Validations.isInvestigationType(this.data)
    let isProjectDesignType = Validations.isProjectDesignType(this.data)
    let isProductsType = Validations.isProductsType(this.data)
    let isProjectsType = Validations.isProjectsType(this.data)
    let isResultsTransferType = Validations.isResultsTransferType(this.data)
    let isOtherActivitiesType = Validations.isOtherActivitiesType(this.data)
    let isRolesType = Validations.isRolesType(this.data)
    let isInternalProjectsFormulationType = Validations.isInternalProjectsFormulationType(this.data)
    let isExtensionProjectsType = Validations.isExtensionProjectsType(this.data)

    let isVisibilityType = Validations.isVisibilityType(this.data)

    let isConsultancyType = Validations.isConsultancyType(this.data)
    let isShortCoursesType = Validations.isShortCoursesType(this.data)
    let isCrossProjectFormulationType = Validations.isCrossProjectFormulationType(this.data)
    let isCrossExtensionProjectsType = Validations.isCrossExtensionProjectsType(this.data)

    angular.extend(this, {
    // variables
      get details () {
        return _details
      },
      set details (value) {
        _details = value
        return value
      },
      get format () {
        return _format
      },
      set format (value) {
        _format.push(value)
        return value
      },

    // methods
      watchEntries: watchEntries()
    })

    function watchEntries () {
      return inExecution || inReviewExecution || inEvaluation
    }

    function setDetails (fields) {
      switch (true) {
        case isSubjectType:
          return fields.subject
        case isPositionByDelegationType:
          return fields.positionByDelegation
        case isCommitteeParticipationType:
          return fields.committee
        case isOtherActivitiesType:
          return fields.otherActivities
        case isRolesType:
          return fields.roles
        case isDoctoralEducationType:
          return fields.doctoralEducation
        case isTeacherDevelopmentType:
          return fields.teacherDevelopment
        case isCommunityType:
          return fields.community
        case inTeaching:
          return fields.teaching
        case isColaborationSpaceType:
          return fields.colaborationSpace
        case isInvestigationType:
          return fields.investigation
        case isProjectDesignType:
          return fields.projectDesign
        case isProductsType:
          return fields.product
        case isProjectsType:
          return fields.project
        case isResultsTransferType:
          return fields.resultsTransfer
        case isInternalProjectsFormulationType:
          return fields.formulateProject
        case isExtensionProjectsType:
          return fields.extensionProject
        case isVisibilityType:
          fields.visibility = emptyFields(fields.visibility)
          return fields.visibility
        case isConsultancyType:
          return fields.consultancy
        case isShortCoursesType:
          return fields.shortCourses
        case isCrossProjectFormulationType:
          return fields.formulateCrossProject
        case isCrossExtensionProjectsType:
          return fields.extensionCrossProject
        default:
          return [['Problemas en el servicio', '404']]
      }
    }

    function setStudents (data) {
      if (objHas(data, 'studentNum') && objHas(data, 'studentTypeName')) {
        if (data.studentNum && data.studentTypeName) {
          let num = data.studentNum.split(',')
          let type = data.studentTypeName.split(',')
          return num.map((amount, index) => {
            return type[index] + ' - ' + amount
          }).join(', ')
        }
      }
    }

    function emptyFields (data) {
      return data.filter(fields => { if (fields[1] !== 'NA') return fields })
    }

    function checkState (start, end, now) {
      if (start < now && now < end) {
        return 'En curso'
      } else if (start > now) {
        return 'No iniciado'
      } else if (now > end) {
        return 'Finalizado'
      } else {
        return 'Desconocido'
      }
    }

    function calcState (data) {
      if (data.startDate) {
        return checkState(setDate(data.startDate), setDate(data.endDate), setDate(new Date()))
      } else {
        return checkState(setDate(data.startPeriod), setDate(data.endPeriod), setDate(new Date()))
      }
    }

    const setRangeData = R.curry((objHas, setDate, unique, data) => {
      if (objHas(data, 'timeRangeTypeId')) {
        if (data.timeRangeTypeId != null) {
          let validator = objHas(data, 'timeRangeTypeId') ? data.timeRangeTypeId : (data.periodicityName ? 1 : 2)
          switch (validator) {
            case 1:
              return [['Periocidad', unique(data.periodicityName).join(', ') || unique(data.periodName).join(', ')]]
            case 2:
              return [
                ['Fecha de Inicio', setDate(data.startDate)],
                ['Fecha de Finalización', setDate(data.endDate)]
              ]
          }
        }
      }
      return []
    })(objHas, setDate, unique)

    const setStartDate = R.curry((objHas, setDate, unique, data) => {
      if (objHas(data, 'timeRangeTypeId')) {
        if (data.timeRangeTypeId != null) {
          let validator = objHas(data, 'timeRangeTypeId') ? data.timeRangeTypeId : (data.periodicityName ? 1 : 2)
          switch (validator) {
            case 1:
              return [['Periocidad', unique(data.periodicityName).join(', ') || unique(data.periodName).join(', ')]]
            case 2:
              return [
                ['Fecha de Inicio', setDate(data.startDate)]
              ]
          }
        }
      }
      return []
    })(objHas, setDate, unique)

    const setEndDate = R.curry((objHas, setDate, unique, data) => {
      if (objHas(data, 'timeRangeTypeId')) {
        if (data.timeRangeTypeId != null) {
          let validator = objHas(data, 'timeRangeTypeId') ? data.timeRangeTypeId : (data.periodicityName ? 1 : 2)
          switch (validator) {
            case 1:
              return []
            case 2:
              return [
                ['Fecha de Finalización', setDate(data.endDate)]
              ]
          }
        }
      }
      return []
    })(objHas, setDate, unique)

    const showExecutionHours = (inHistory, hours, totalHours) => [(inHistory && !inExecution) ? [] : ['Horas ejecutadas', (hours || totalHours) || 0]]


    const setFields = R.curry((showExecutionHours, setDate, setStudents, setRangeData, data) => {

      var res = {
        subject: [
          ['Carga Horaria', data.loadTime || 0],
          ['Número de grupos', data.groupsTempName || 'No hay grupos asignados'],
          ['Idioma', data.language || 'Español'],
          ['N° de estudiantes', data.numberStudents || 0],
          ['Total de horas planeadas de docencia directa', data.hoursPlanned || 0],
          ['Horas Planeadas SIAR', data.hoursExecutedSiar || 0],
          ['Horas planeadas de docencia directa por grupo', data.hoursPlanned / data.groupsTempNum || 0],
          ['Horas Ejecutadas SIAR', data.hoursPlannedSiar || 0],
          ['Horas Ejecutadas', data.hoursExecuted || 0],
          ['Observaciones', data.description || 'Sin observaciones'],
          ['Relación entre horas docencia directa y horas preparación de clase', data.relationship || 0]
        ],
        positionByDelegation: [
          ['Unidad', data.academicUnitName || 'Sin unidad académica asignada'],
          ...setStartDate(data),
          ['Horas Planeadas', data.hoursPlanned || data.activityHoursPlaned || 0],
          ...setEndDate(data),
          ['Porcentaje Planeado', data.percentagePanning + '%' || 'Sin porcentaje planeado'],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0),
          ['Observaciones', data.description || 'Sin observaciones']
        ],
        otherActivities: [
          ['Horas Planeadas', data.hoursPlanned || data.activityHoursPlaned || 0],
          ...setStartDate(data),
          ['Horas Ejecutadas', data.totalHoursExecuted || 0],
          ...setEndDate(data),
          ['Observaciones', data.description || 'Sin observaciones']
        ],
        roles: [
          ['Horas Planeadas', data.hoursPlanned || data.activityHoursPlaned || 0],
          ...setStartDate(data),
          ['Horas Ejecutadas', data.totalHoursExecuted || 0],
          ...setEndDate(data),
          ['Observaciones', data.description || 'Sin observaciones']
        ],
        committee: [
          // ['Unidad', data.academicUnitName || 'Sin unidad académica asignada'],
          ...setStartDate(data),
          ['Horas Planeadas', data.hoursPlanned || 0],
          ...setEndDate(data),
          ...showExecutionHours(inHistory, data.hoursExecuted, 0),
          ['Observaciones', data.description || 'Sin observaciones']
        ],
        doctoralEducation: [
          ['Institución', data.nameInstitute || 'Sin institución asignada'],
          ['Tipo de institución', data.typeInstitute || 'Sin tipo de institución asignado'],
          ['País', data.country || 'Sin país asignado'],
          ['Ciudad', data.cityName || 'Desconocido'],
          ['Departamento', data.stateName || 'Desconocido'],
          ['Nucleo', data.knowledgeCoreName || 'Sin nucleo asignado'],
          ...setRangeData(data),
          ['Horas Planeadas', data.hoursPlanning || 0],
          ['Horas Ejecutadas', data.totalHoursExecuted || 0],
          ['Financiamiento', data.financingName || 'Sin financiamiento'],
          ['Beca', data.scholarshipName || 'No posee beca']
        ],
        teacherDevelopment: [
          ['Modalidad', data.modalityName],
          ['Profesor', data.teacherCourse ? data.teacherCourse : 'No aplica'],
          ['Idioma', data.languajeCourse ? data.languajeCourse : 'No aplica'],
          ['Horario', data.scheduleCourse ? data.scheduleCourse : 'No aplica'],
          ['Tipo de entidad', data.entityName || 'Sin tipo asignado'],
          ['Horas Planeadas', data.totalHoursPlanned ? data.totalHoursPlanned : 0],
          ['Horas Ejecutadas', data.totalHoursExecuted || 0],
          ...setRangeData(data),
          ['Institución', data.nameInstitute ? data.nameInstitute : 'No aplica'],
          ['Tipo de Institución', data.instituteTypeName ? data.instituteTypeName : 'No aplica'],
          ['Programa', data.nameStudy ? data.nameStudy : 'Sin programa']
        ],
        community: [
          ['Ámbito/Escenario', data.listItemNameAmbit || 'Sin ámbito asignado'],
          ...setRangeData(data),
          ['Horas Planeadas', data.totalHoursPlanned ? data.totalHoursPlanned + ' hrs.' : '0 hrs.']
        ],
        colaborationSpace: [
          ['Ámbito/Escenario local', data.ambitColaborationName || '-'],
          ['Tipo', data.typeSpaceName],
          ['Tipo de participación', data.typeParticipationName],
          ['Descripción y justificación', data.description],
          ['Resultados', data.results],
          ['Entidad/Organizador', data.entityName || '-'],
          ['Enlace', data.link || '-'],
          ['Ciudad', data.cityName || 'Sin ciudad asignada'],
          ['Pais', data.countryName || 'Sin país asignado'],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanning || '0'],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0)
        ],
        investigation: [
          ['Tipo de actividad formativa', data.itemTypeSpaceName],
          ['Descripción', data.description || '-'],
          ['Resultados', data.resultsExpected],
          ['Enlace', data.link || '-'],
          ['Cantidad de estudiantes', setStudents(data)],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanning || '0'],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0)
        ],
        projectDesign: [
          ['Rol', data.roleName],
          ['Tipos de financiador(es)', objHas(data, 'financialName') ? unique(data.financialName).join(', ') : 'NA'],
          ['Resumen', data.summary],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanning],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0)
        ],
        product: [
          ['Área básica de conocimiento', data.itemKnowledgeName],
          ['Tipo de producto', data.itemProductName],
          ['Subtipo', data.subItemProductName],
          ['Proyecto asociado', data.projectName],
          ['Descripción', data.description],
          ...setRangeData(data),
          ['Horas planeadas', (data.hoursPlanned || data.totalPlannedHours) || 0],
          ...showExecutionHours(inHistory, data.hoursExecuted, data.totalExecutedHours)
        ],
        project: [
          ['Tipo de proyecto', data.listItemProjectTypeName],
          ['Estado', data.estatus],
          ['Descripción', data.description],
          ['Unidad Académica', data.academicUnitName],
          ['Rol en el proyecto', data.listItemProjectRoleName],
          ['Financiadores', objHas(data, 'financialSourceName') ? unique(data.financialSourceName).join(', ') : 'No posee financiadores'],
          ...setRangeData(data),
          ...showExecutionHours(inHistory, data.totalExecutedHours, 0)
        ],
        resultsTransfer: [
          ['Tipo de resultado', data.itemResultsName],
          ['Descripción', data.description],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanned],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0)
        ],
        formulateProject: [
          ['Aliados potenciales', data.potencialAllies],
          ['Tipo de proyecto', data.typeProject],
          ['Financiadores', objHas(data, 'typeFinanciers') ? unique(data.typeFinanciers).join(', ') : 'No posee financiadores'],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanned],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0),
          ['Resumen', data.summary]
        ], // Proyectos Internos
        extensionProject: [
          ['Rol en el proyecto', data.listItemProjectRoleName],
          ['Tipo de proyecto', data.listItemProjectTypeName],
          ['Propuesta asociada', data.projectFormulatedName],
          ['Unidad académica', data.academicUnitName || 'Sin unidad académica asignada'],
          ['Financiadores', objHas(data, 'financialSourceName') ? unique(data.financialSourceName).join(', ') : 'No posee financiadores'],
          ['Estado', data.estatus],
          ['Descripción', data.description],
          ...setRangeData(data),
          ['Horas planeadas', (data.hoursPlanned || data.totalPlannedHours) || 0],
          ...showExecutionHours(inHistory, data.hoursExecuted, data.totalExecutedHours)
        ],
        visibility: [
          ['URL', data.link || 'NA'],
          ['Rol', data.nameRol || 'NA'],
          ['Ámbito', data.nameAmbit || 'NA'],
          ['Unidad', data.unitName || 'NA'],
          ['Contacto', data.contact || 'NA'],
          ['Sector', data.nameSector || 'NA'],
          ['Correo Electrónico', data.email || 'NA'],
          ['Registro de comunicación', data.nameCommunicationRegister],
          ['Tipo de comunicación', data.nameCommunicationType || 'NA'],
          ['Frecuencia de emisión', data.nameFrequencyEmission || 'NA'],
          ['Audiencia', data.nameAudience || 'NA'],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanned],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0),
          ['Resumen', data.summary]
        ],
        consultancy: [
          ['Área básica del conocimiento', data.itemKnowledgeName],
          ['Descripción', data.description],
          ['Empresa/Entidad/Organización', data.entity],
          ['Fuente', objHas(data, 'source') ? unique(data.source).join(', ') : 'No posee financiadores'],
          ['Ámbito/Escenario', data.itemAmbitName],
          ['Sector', data.itemSectorName],
          ['Rol', data.itemRoleName],
          ['Productos/Entregables', data.deliverables],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanned],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0)
        ],
        shortCourses: [
          ['Modalidad', data.itemModalityName],
          ['Descripción', data.description],
          ['Rol', data.itemRoleName],
          ['Tipo de curso', data.itemTypeCourseName],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanned],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0)
        ],
        formulateCrossProject: [
          ['Tipo de proyecto', data.typeProject],
          ['Aliados potenciales', data.potencialAllies],
          ['Tipo de financiamiento', objHas(data, 'typeFinanciers') ? unique(data.typeFinanciers).join(', ') : 'No posee financiadores'],
          ...setRangeData(data),
          ['Horas planeadas', data.hoursPlanned],
          ...showExecutionHours(inHistory, data.hoursExecuted, 0),
          ['Resumen', data.summary]
        ],
        extensionCrossProject: [
          // ['Nombre del proyecto', data.projectName],
          ['Objetivos del proyecto', data.objectives],
          ['Propósitos del proyecto', data.purposes],
          ['Metodología del proyecto', data.methodology],
          ['Comunidades implicadas', data.listItemProjectRoleName],
          ['Resultados/ Productos', data.results],
          ['Nombre de archivo PDF', data.file],
          ['Tipo de proyecto de extensión', data.itemProjectTypeName],
          ['Valor del proyecto', data.value],
          ...showExecutionHours(inHistory, data.hoursExecuted, data.totalExecutedHours)
        ]
      }

      // se agregan dos campos que se estaban mostrando cuando NO estaba en historial
      if (!inHistory) {
        // Consolidacion CP -> Formación doctoral
        res.doctoralEducation.push(['Estado', calcState(data)])
        res.doctoralEducation.push(['Observaciones', data.description || 'Sin observaciones'])
        // Consolidacion CP -> Desarrollo profesoral
        res.teacherDevelopment.unshift(['Categoría', data.categoryCourse ? data.categoryCourse : 'No aplica'])
        res.teacherDevelopment.push(['Sede', data.cityName || 'Sin sede asignada'])
        res.teacherDevelopment.push(['Estado', calcState(data)])
        // Consolidacion CP -> Comunidades
        if (!inApproval && !inReview) {
          res.community.push(['Horas Ejecutadas', data.totalHoursExecuted ? data.totalHoursExecuted + ' hrs.' : '0 hrs.'])
        }
        res.community.push(['Estado', calcState(data)])
      }
      res.community.push(['Descripción de su labor', data.description || 'Sin descripción'])
      return res
    })(showExecutionHours, setDate, setStudents, setRangeData)

    function cleanFields (details) {
      details.forEach((field, index, arr) => {
        if (Array.isArray(field) && field[0] === '-') {
          arr.splice(index, 1)
        }
      })
    }

    this.$onInit = () => {
      this.format = this.stackItems ? ['col-md-12', 'col-md-7'] : ['col-md-6', 'col-md-12']
      this.details = setDetails(setFields(this.data))
      cleanFields(this.details)
    }

    GlobalSrv.subscribe($scope, $rootScope, 'hoursChanged', (hours) => {
      this.data.hoursExecuted = hours
      this.data.totalHoursExecuted = hours
      this.data.totalExecutedHours = hours
      this.details = setDetails(setFields(this.data))
      cleanFields(this.details)
    })
  }
]}



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details/main-info.js